<template>
    <div>
        <div class="user_right">
            <div class="ov lh35">
                <h1 class="urs_h1" style="float:left">意见反馈</h1>
                <span class="right c9" style="font-size:16px;">
                    <a href="javascript:jieshou();">咨询在线客服</a>
                </span>
            </div>
            <div class="mt35">
                <div>
                    <table width="" border="0" class="td_p f14">
                        <tbody>
                            <tr>
                                <td valign="top" width="90">类型</td>
                                <td>
                                    <span v-for="(item, k) in pro_option" :key="k" :class="[item.is_active == 1 ? 'active_problem' : '']" @click="pro_btn(item)" class="aaaa">{{ $h(item.title) }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td valign="top" width="90">留言信息</td>
                                <td>
                                    <div class="ap_t">
                                        <textarea maxlength="800" name="" placeholder="请输入您的留言信息，登录后提交可查看回复,6-200个字" class="aea" id="c_des"  v-model="sub_form.message"></textarea>
                                        <p class="alR c9 mt10" id="zisu">{{ num }}/200</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td width="90">联系人</td>
                                <td>
                                    <input type="text" name="mobile" id="mobile" value="" maxlength="15" size="30" class="ipt" v-model="sub_form.username" style="width: 90%" placeholder="请输入" clearable>
                                </td>
                            </tr>
                            <tr>
                                <td width="90">联系方式</td>
                                <td>
                                    <input type="text" name="mobile" id="mobile" value="" maxlength="15" size="30" class="ipt" v-model="sub_form.tel" style="width: 90%" placeholder="请输入" clearable>
                                </td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>
                                    <input type="hidden" name="act" value="msg">
                                    <input type="submit"  @click="sub_btn" class="b_sub" :value="$h('提交反馈')">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="lh30">&nbsp;</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            num: 0,
            pro_option: [],
            sub_form: {
                tel: JSON.parse(window.localStorage.getItem("user")).tel,
                username: JSON.parse(window.localStorage.getItem("user")).nickname,
                reason: "",
                cardpositive: "",
                message: "",
                file_list: "",
            },
        }
    },
    created() {
        this.get_pro_option();
    },
    methods:{
        get_pro_option() {
            this.$api.getUser.get_complaint_pro().then((res) => {
                if (res.code == 200) {
                res.result.forEach((item) => {
                    var params = {
                        title: item,
                        is_active: "0",
                    };
                    this.pro_option.push(params);
                });
                }
            });
        },
        pro_btn(obj) {
            this.pro_option.forEach((item) => {
                item.is_active = 0;
            });
            obj.is_active = 1;
            this.sub_form.reason = obj.title;
        },
        sub_btn() {
            var params = {
                types: this.sub_form.reason,
                content: this.sub_form.message,
                man: this.sub_form.username,
                tel: this.sub_form.tel,
                uid: JSON.parse(window.localStorage.getItem("user")).id
            };
            this.$api.getUser.submit_complaint(params).then((res) => {
                if (res.code == 200) {
                    // this.$toast.fail(this.$h("已提交"), 1000);
                    // setTimeout(() => {
                    //     this.toBack();
                    // }, 1500);
                    this.$alert(`${this.$h("已提交")}`, '提示', {
                        confirmButtonText: '确定',
                    });
                } else {
                    this.$alert(`${res.result}`, '提示', {
                        confirmButtonText: '确定',
                    });
                }
            });
        },
    },
    computed: {
        getName() {
            return this.sub_form.message;
        },
    },
    watch: {
        getName(old, after) {
            this.num = old.length;
            if (old.length > 200) {
                this.sub_form.message = String(old).slice(0, 200);
            }
        },
    },
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
.f14 {
    font-size: 14px;
}
.pr10 {
    padding-right: 10px;
}
.bgwd{background-color:#fff;padding:20px;}
.td_p td{padding:10px;}
.msg_list{background-color:#fff;padding:15px;margin-bottom:10px;line-height:50rpx;font-size:14px;color:#333;}
.msg_time,.rep_time{font-size:12px;color:#999;display: block;margin-top:10px;}
.rep{background-color:#f9f9f9;padding:10px;border-radius:4px;margin-top:10px;font-size:12px;line-height:20px;color:#666;}
.ipt{line-height:42px;height:42px;border:1px solid #efefef;border-radius:4px;padding:0 10px;}
.ap_t{border:1px solid #efefef;padding:10px;border-radius:8px;margin-bottom:10px;line-height:2rem;background-color:#fff;width:650px;}
.aea{height:10rem;width:100%;border:none;background:none;}
.active_problem {
  background-color: #dc5c3f;
  color: #ffffff !important;
  border: none !important;
}
.aaaa{
    border:1px solid #999;
    border-radius: 5px;
    padding:10px;
    margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/faq/Index.vue